import { jsxs as o, jsx as e } from "@emotion/react/jsx-runtime";
import { DocumentThumbContainer as s, FileDetails as d, ActionContainer as l, RemoveIcon as p } from "./DocumentThumb.styled.js";
import { Icon as u } from "../../Icon/index.js";
import { Text as n } from "../../Text/index.js";
import { convertHumanSize as f } from "../helpers.js";
import { DocumentSvg as h } from "../icons/DocumentSvg.js";
import { FontAwesomeIconsPartooUsed as b } from "../../../types/components/icon.js";
const z = ({
  icon: r = /* @__PURE__ */ e(h, { state: "success" }),
  file: t,
  remove: a
}) => {
  const {
    name: i,
    size: m
  } = t, c = f(m);
  return /* @__PURE__ */ o(s, { direction: "row", alignItems: "center", justifyContent: "space-between", children: [
    /* @__PURE__ */ e(u, { icon: r, iconSize: "32px" }),
    /* @__PURE__ */ o(d, { gap: "0", children: [
      /* @__PURE__ */ e(n, { variant: "bodyMSemibold", as: "span", children: i }),
      /* @__PURE__ */ e(n, { variant: "bodySRegular", as: "span", color: "secondary", children: c })
    ] }),
    /* @__PURE__ */ e(l, { children: /* @__PURE__ */ e(p, { dataTrackId: "remove-document-thumb", "aria-label": "Remove document", icon: [b.faTrash], appearance: "outlined", variant: "danger", onClick: a }) })
  ] });
};
export {
  z as DocumentThumb
};
